import { enablePatches, enableMapSet } from 'immer';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';

enablePatches();
enableMapSet();
